<template>
  <standard-dialog
    v-model="model"
    :title="formTitle"
    :max-width="1000"
    icon="mdi-store"
    @save="save"
    :disabled="!valid"
  >
    <template #title-actions>
      <primary-button
        v-if="editedItem?.settings?.lice_bez_ugovora"
        small
        color="white"
        :dark="!loadingQr"
        class="mr-4"
        @click="generateQRCode"
        :loading="loadingQr"
      >
        <v-icon color="primary" class="mr-2">mdi-checkerboard</v-icon>
        <span class="primary--text">{{ $t("qr") }}</span>
      </primary-button>
    </template>
    <v-container>
      <v-form v-model="valid">
        <v-row>
          <v-col cols="12">
            <span class="caption font-weight-medium">{{ $t("type") }}</span>
            <v-radio-group row v-model="editedItem.entity_type">
              <v-radio :label="$t('restaurant')" value="restaurant"></v-radio>
              <v-radio :label="$t('shop')" value="shop"></v-radio>
              <v-radio :label="$t('post')" value="delivery"></v-radio>
            </v-radio-group>
            <v-switch
              @click="switchStatus"
              v-model="editedItem.state"
              inset
              :label="$t('status')"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <text-field
              v-model="editedItem.name"
              :label="$t('title')"
              required
              :rules="[rules.required]"
            ></text-field>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <autocomplete
              v-model="editedItem.parent"
              :items="userRestorans.filter((item) => item.id)"
              :label="$t('parent_restaurant')"
              item-text="name"
              item-id="id"
              return-object
            ></autocomplete>
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <text-field
              v-model="editedItem.email"
              :label="$t('email')"
              required
              :rules="[rules.required]"
            ></text-field>
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <text-field
              v-model="editedItem.phone"
              :label="$t('phone')"
              required
              :rules="[rules.required]"
            ></text-field>
          </v-col>

          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <autocomplete
              @change="$emit('change-country')"
              v-model="editedItem.country"
              :items="countries"
              :label="$t('country')"
              required
              :rules="[rules.required]"
              item-text="name"
              item-id="id"
              return-object
            ></autocomplete>
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <autocomplete
              v-model="editedItem.city"
              :items="cities ? cities : []"
              :label="$t('city')"
              required
              :rules="[rules.required]"
              item-text="name"
              item-id="id"
              return-object
            ></autocomplete>
          </v-col>

          <v-col cols="12" md="6" lg="4">
            <text-field
              v-model="editedItem.address"
              :label="$t('address')"
              required
              :rules="[rules.required]"
            >
            </text-field>
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <text-field v-model="editedItem.latitude" :label="$t('lati1')">
            </text-field>
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <text-field v-model="editedItem.longitude" :label="$t('long1')">
            </text-field>
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <text-field
              v-model="editedItem.delivery_distance"
              type="number"
              :label="$t('delivery_distance')"
            >
            </text-field>
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
                <text-field v-model="editedItem.lib" :label="$t('jib')"></text-field>
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <text-field v-model="editedItem.pib" :label="$t('pib')"></text-field>
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <text-field v-model="editedItem.owner" :label="$t('owner')"></text-field>
          </v-col>
          <v-col cols="12" md="6" lg="4" class="mb-0 pb-0">
            <text-field
              v-model="editedItem.contact_person"
              :label="$t('contact_person')"
            ></text-field>
          </v-col>
          <v-col cols="12" class="mb-4 pb-0">
            <h4>{{ $t("pay_type") }}</h4>
            <v-row no-gutters>
              <v-switch
                v-model="editedItem.restoran_tip_ugovora.paying_type"
                inset
                :label="$t('by_month')"
                :false-value="0"
                :true-value="1"
                @change="changeAmountMonth"
                dense
              ></v-switch>
              <v-switch
                v-model="editedItem.restoran_tip_ugovora.paying_type"
                inset
                :label="$t('by_percent')"
                @change="changeAmountPercent"
                :false-value="0"
                :true-value="2"
                dense
              ></v-switch>
              <v-switch
                v-model="editedItem.restoran_tip_ugovora.paying_type"
                inset
                :label="$t('by_meal')"
                @change="changeAmountMeal"
                :false-value="0"
                :true-value="3"
                dense
              ></v-switch>
            </v-row>
            <text-field
              v-if="editedItem.restoran_tip_ugovora.paying_type"
              type="number"
              v-model="editedItem.restoran_tip_ugovora.amount"
              :label="
                $t('amount') +
                ' ' +
                (editedItem.restoran_tip_ugovora.paying_type == 2
                  ? '%'
                  : $store.state.restaurant.settings.price
                  ? $store.state.restaurant.settings.price
                  : '')
              "
            ></text-field>
          </v-col>

          <v-row no-gutters v-if="user.type === 'admin'">
            <v-col cols="auto">
              <v-switch
                inset
                label="Ankete"
                hide-details
                class="mt-3 pr-4"
                v-model="localHasQuestionare"
                @change="
                  localHasQuestionare
                    ? localQuestionares.push({ qid: null, roles: [] })
                    : (localQuestionares = [])
                "
              ></v-switch>
            </v-col>
            <v-col>
              <v-row>
                <template v-for="(questionare, i) in localQuestionares">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="3">
                        <text-field
                          label="ID Ankete"
                          v-model="questionare.qid"
                          dense
                          :disabled="!localHasQuestionare"
                          hide-details
                        ></text-field>
                      </v-col>
                      <v-col cols="7">
                        <autocomplete
                          v-model="questionare.roles"
                          :label="$t('role')"
                          :items="['admin', 'guest', 'customer']"
                          :disabled="!localHasQuestionare"
                          multiple
                          small-chips
                          deletable-chips
                          dense
                          hide-details
                        >
                        </autocomplete>
                      </v-col>
                      <v-col cols="2">
                        <v-row
                          v-if="i === localQuestionares.length - 1"
                          no-gutters
                          justify="center"
                          align="center"
                          class="fill-height"
                        >
                          <circle-button
                            icon="mdi-minus"
                            :disabled="!localHasQuestionare"
                            color="primary"
                            @click="localQuestionares.splice(i, 1)"
                          />
                          <circle-button
                            icon="mdi-plus"
                            :disabled="!localHasQuestionare"
                            color="primary"
                            @click="
                              localQuestionares.push({
                                qid: null,
                                roles: [],
                              })
                            "
                          />
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </template>
              </v-row>
            </v-col>
          </v-row>
        </v-row>
      </v-form>
    </v-container>

    <qr-code-dialog v-model="qrDialog" :qr-secret="qrSecret" />
  </standard-dialog>
</template>

<script>
import StandardDialog from "@/components/dialogs/StandardDialog.vue";
import QrCodeDialog from "./QrCodeDialog.vue";
import hasModel from "@/mixins/hasModel";
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import restaurantService from "@/services/restaurant";

export default {
  name: "RestaurantEditDialog",
  mixins: [hasModel, hasValidation, hasSnackbar],
  components: {
    StandardDialog,
    QrCodeDialog,
  },
  props: {
    editedItem: {
      type: Object,
      required: true,
    },
    userRestorans: {
      type: Array,
      default: () => [],
    },
    countries: {
      type: Array,
      default: () => [],
    },
    cities: {
      type: Array,
      default: () => [],
    },
    questionares: {
      type: Array,
      default: () => [],
    },
    hasQuestionare: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localQuestionares: [],
      localHasQuestionare: false,
      qrDialog: false,
      qrSecret: "",
      loadingQr: false,
    };
  },
  watch: {
    questionares: {
      handler(newVal) {
        this.localQuestionares = [...newVal];
      },
      immediate: true,
      deep: true,
    },
    hasQuestionare: {
      handler(newVal) {
        this.localHasQuestionare = newVal;
      },
      immediate: true,
    },
    localQuestionares: {
      handler(newVal) {
        this.$emit("update:questionares", newVal);
      },
      deep: true,
    },
    localHasQuestionare: {
      handler(newVal) {
        this.$emit("update:hasQuestionare", newVal);
      },
    },
  },
  methods: {
    changeAmountMonth() {
      if (this.editedItem.restoran_tip_ugovora.paying_type == 1) {
        this.editedItem.restoran_tip_ugovora.paying_type = 1;
      } else {
        this.editedItem.restoran_tip_ugovora.paying_type = 0;
      }
      this.$forceUpdate();
    },
    changeAmountPercent() {
      if (this.editedItem.restoran_tip_ugovora.paying_type == 2) {
        this.editedItem.restoran_tip_ugovora.paying_type = 2;
      } else {
        this.editedItem.restoran_tip_ugovora.paying_type = 0;
      }
      this.$forceUpdate();
    },
    changeAmountMeal() {
      if (this.editedItem.restoran_tip_ugovora.paying_type == 3) {
        this.editedItem.restoran_tip_ugovora.paying_type = 3;
      } else {
        this.editedItem.restoran_tip_ugovora.paying_type = 0;
      }
      this.$forceUpdate();
    },
    switchStatus() {
      restaurantService.changeRestaurantStatus(this.editedItem);
    },
    generateQRCode() {
      this.loadingQr = true;
      restaurantService
        .generateRestaurantCode(this.editedItem)
        .then(({ data }) => {
          this.qrSecret = data;
          this.qrDialog = true;
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_generating_qr_code"));
        })
        .finally(() => {
          this.loadingQr = false;
        });
    },
    save() {
      this.$emit("save");
    },
  },
  computed: {
    formTitle() {
      return !this.editedItem.id
        ? this.$t("new_restaurant")
        : this.$t("restaurant") + ": " + this.editedItem.id;
    },
    user() {
      return this.$store.state.user.user;
    },
  },
};
</script>
